import type { PageCard } from '@/play/pageTypes'
import { SpellItCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'spell-it',
  number: 27,
  title: 'Spell it',
  question: 'When a word is spoken, can a child build it from letter blocks, and does the world answering the finished word feel like a reward?',
  status: 'open',
  accent: '#cfe3f2',
  CardArt: SpellItCardArt,
}
